import { Suspense, lazy } from 'react';

const PlainTextContentInner = lazy(() => import('./PlainTextContent'));

export const PlainTextContent = ({ children }: { children: string }) => (
  <Suspense fallback={null}>
    <PlainTextContentInner>{children}</PlainTextContentInner>
  </Suspense>
);
